import { FunctionComponent } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

// Chat (/chat) — will be implemented soon: add `Chat` to the import below and uncomment the route next to the note in <Routes>.
import {
    ForgotPassword,
    Login,
    Patient,
    PatientDetail,
    Report,
    ResetPassword,
    Scan,
    Upload,
    Analytics,
    RetinaTrack,
    RetinaPatientDetail,
    RetinaUpload,
    MultiToolDisplay,
    TimelineTraceView,
    NotFound,
    Scans,
    ResultPage,
    Settings,
    GetStarted,
} from './pages';
import { ProtectedRoute } from './components/ProtectedRoute';
import store from './store';

const App: FunctionComponent = () => {
    return (
        <Provider store={store}>
            <BrowserRouter>
                <Routes>
                    {/* Public routes */}
                    <Route path="/" element={<Login />} />
                    <Route path="/reset-password" element={<ResetPassword />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />

                    {/* Protected routes */}
                    <Route path="/patient/:patientId/scan/:scanId/report" element={<ProtectedRoute><Report /></ProtectedRoute>} />
                    <Route path="/patients" element={<ProtectedRoute><Patient /></ProtectedRoute>} />
                    <Route path="/patients/:patientId" element={<ProtectedRoute><PatientDetail /></ProtectedRoute>} />
                    <Route path="/patient/:patientId/scan" element={<ProtectedRoute><Scan /></ProtectedRoute>} />
                    <Route path="/rawdata" element={<ProtectedRoute><Scan /></ProtectedRoute>} />
                    <Route path="/upload" element={<ProtectedRoute><Upload /></ProtectedRoute>} />
                    <Route path="/retina" element={<ProtectedRoute><RetinaTrack /></ProtectedRoute>} />
                    <Route path="/retina/upload" element={<ProtectedRoute><RetinaUpload /></ProtectedRoute>} />
                    <Route path="/retina/patient/:patientId" element={<ProtectedRoute><RetinaPatientDetail /></ProtectedRoute>} />
                    <Route path="/tools" element={<ProtectedRoute><MultiToolDisplay /></ProtectedRoute>} />
                    <Route path="/timeline" element={<ProtectedRoute><TimelineTraceView /></ProtectedRoute>} />
                    <Route path="/scans" element={<ProtectedRoute><Scans /></ProtectedRoute>} />
                    <Route path="/scans/:jobId/result" element={<ProtectedRoute><ResultPage /></ProtectedRoute>} />
                    <Route path="/analytics" element={<ProtectedRoute><Analytics /></ProtectedRoute>} />
                    {/* /chat — will be implemented soon: import Chat, then:
                    <Route path="/chat" element={<ProtectedRoute><Chat /></ProtectedRoute>} />
                    */}
                    <Route path="/get-started" element={<ProtectedRoute><GetStarted /></ProtectedRoute>} />
                    <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
                    <Route path="/sessions" element={<ProtectedRoute><NotFound /></ProtectedRoute>} />

                    {/* Catch-all */}
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </BrowserRouter>
        </Provider>
    );
};

export default App;